import { render, staticRenderFns } from "./deptUserSelect.vue?vue&type=template&id=10275404"
import script from "./deptUserSelect.vue?vue&type=script&lang=js"
export * from "./deptUserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports